var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.524 2c1.158 0 2.18.469 2.918 1.22a4.157 4.157 0 0 1 1.183 2.923c0 .793-.227 1.525-.62 2.147l2.311 4.608 3.436-2.74a3.565 3.565 0 0 1-.05-.587 4.14 4.14 0 0 1 4.15-4.143 4.14 4.14 0 0 1 2.93 1.212A4.126 4.126 0 0 1 37 9.57a4.126 4.126 0 0 1-1.218 2.932c-.344.344-.75.627-1.198.833l-2.519 13.62A3.714 3.714 0 0 1 28.407 30v.001H10.642a3.716 3.716 0 0 1-3.66-3.049L4.505 13.36a4.186 4.186 0 0 1-1.236-.818A4.085 4.085 0 0 1 2 9.571c0-1.134.47-2.168 1.223-2.919A4.165 4.165 0 0 1 6.15 5.429c1.109 0 2.16.46 2.926 1.223a4.119 4.119 0 0 1 1.224 2.92c0 .213-.018.421-.051.624l3.387 2.702 2.312-4.61a3.99 3.99 0 0 1-.62-2.145c0-1.144.476-2.186 1.25-2.941A4.228 4.228 0 0 1 19.524 2Z",
    fill: "#4CC2F1",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.76614226aa61298184f02961236e09a3.svg";
export { ForwardRef as ReactComponent };